export const CATEGORY_COLORS = {
  Firefighter: 'var(--color-cat-firefighter)',
  EMS: 'var(--color-cat-ems)',
  EMT: 'var(--color-cat-ems)',
  Police: 'var(--color-cat-police)',
  Rescue: 'var(--color-cat-rescue)',
  Lifeguard: 'var(--color-cat-lifeguard)',
  Security: 'var(--color-cat-security)',
  ADMIN: 'var(--color-cat-admin)',
  AHA: 'var(--color-cat-aha)',
  TACTICAL: 'var(--color-cat-tactical)',
  Other: 'var(--color-cat-other)',
};

export function getCategoryColor(category) {
  return CATEGORY_COLORS[category] || CATEGORY_COLORS.Other;
}
